import { useEffect, useState } from "react";
import { setLoading } from "../../store/slices/auth";
import { useDispatch } from "react-redux";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import ModalPopup from "../../widgets/modal";
import ModalComponent from "../common/Modal/modal";
import { deletePrintableTemplate, getPrintableTemplates } from "./apiController";
import CreateTemplate from "./CreateTemplate";

const PrintableTemplate = (props) => {
    const { projectData, onClose, forms } = props;
    const [action, setAction] = useState<any>("");
    const [templates, setTemplates] = useState<any>([]);
    const [selectedTemplate, setSelectedTemplate] = useState<any>();
    const dispatch = useDispatch();

    useEffect(() => {
        fetchTemplates();
    }, []);

    async function fetchTemplates() {
        dispatch(setLoading(true));
        try {
            const response = await getPrintableTemplates(projectData.TopicID);
            setTemplates(response.data || []);
        } catch (error) {
            showToaster(toasterTypes.ERROR, "Failed To Fetch Templates");
        } finally {
            dispatch(setLoading(false));
        }
    }

    const handleClose = () => {
        setAction("");
        setSelectedTemplate(undefined);
        fetchTemplates();
    };

    const handleDelete = async () => {
        setAction("");
        const template = selectedTemplate;
        dispatch(setLoading(true));
        try {
            const response = await deletePrintableTemplate(template?.id || "");
            if (response.status) {
                showToaster(toasterTypes.SUCCESS, response.message || "Template Deleted Successfully");
                fetchTemplates();
            }
        } catch (error) {
            showToaster(toasterTypes.ERROR, "Failed To Delete Template");
        } finally {
            dispatch(setLoading(false));
        }
    };

    const onAction = (data, type = "") => {
        switch (type) {
            case "deleteTemplate":
                setSelectedTemplate(data);
                setAction(type);
                break;

            case "updateTemplate":
                setSelectedTemplate(data);
                setAction(type);
                break;

            case "viewTemplate":
                setSelectedTemplate(data);
                setAction(type);
                break;

            default:
                setAction(type);
                break;
        }
    };

    function getFormName(formId) {
        let temp = forms.find((f) => f.id === formId);
        return temp?.form_name || "Unknown Form";
    }

    return (
        <>
            {(action === "add" || action === "updateTemplate") && (
                <CreateTemplate
                    projectData={projectData}
                    previousState={selectedTemplate}
                    isUpdate={action === "updateTemplate"}
                    forms={forms}
                    onClose={handleClose}
                />
            )}

            {action === "deleteTemplate" && (
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to delete this template?"
                    closeModal={() => setAction("")}
                    onAction={() => handleDelete()}
                />
            )}

            {action === "viewTemplate" && (
                <ModalComponent
                    width={"60%"}
                    isOpen={true}
                    onClose={() => setAction("")}
                    header={`Template Details: ${selectedTemplate?.title}`}
                    centered={true}
                    customClass="view-printable-template-modal"
                    body={
                        <div className="printable-template-details-body">
                            <div className="printable-template-detail-item">
                                <strong>Template Title:</strong>
                                <p>{selectedTemplate?.title}</p>
                            </div>
                            <div className="printable-template-detail-item">
                                <strong>Sections:</strong>
                                <ul className="printable-template-sections-list">
                                    {selectedTemplate?.forms?.map((section, index) => (
                                        <li key={index} className="printable-template-section-item">
                                            <div>
                                                <strong>Section {index + 1}:</strong> {section.section_title}
                                            </div>
                                            <div>
                                                <strong>Form:</strong> {getFormName(section.form_id)}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    }
                    footer={<></>}
                />
            )}

            <div className={window.innerWidth < 768 ? "printable-template-container-mobile" : "printable-template-container"}>
                <div className="printable-template-head">
                    <div className="printable-template-head-text">
                        {projectData && projectData.TopicDesc} - Templates
                    </div>
                    <div className="printable-template-close-btn">
                        <i className="icon icon-close" onClick={() => onClose()}></i>
                    </div>
                </div>

                <div className="printable-template-content">
                    <div className="printable-template-btn-container">
                        <CustomButton
                            type={"primary"}
                            text={"Add Template"}
                            onClick={() => setAction("add")}
                        />
                    </div>
                </div>

                <div className="printable-template-list">
                    <h4>Templates List</h4>
                    {templates?.length === 0 ? (
                        <p>No templates found.</p>
                    ) : (
                        <ul className="printable-template-items">
                            {templates?.map((template, index) => (
                                <li key={index} className="printable-template-item">
                                    <div className="printable-template-item-header">
                                        <strong>{template.title}</strong>
                                    </div>
                                    <div className="printable-template-item-content">
                                        <div>
                                            <strong>Number of Sections:</strong> {template.forms?.length || 0}
                                        </div>
                                        <div>
                                            <strong>Forms:</strong>{" "}
                                            {template.forms
                                                ?.map((section) => getFormName(section.form_id))
                                                .join(", ")}
                                        </div>
                                    </div>
                                    <div className="printable-template-item-actions">
                                        <CustomButton
                                            type={"secondary"}
                                            text={"View"}
                                            onClick={() => onAction(template, "viewTemplate")}
                                        />
                                        <CustomButton
                                            type={"primary"}
                                            text={"Update"}
                                            onClick={() => onAction(template, "updateTemplate")}
                                        />
                                        <CustomButton
                                            type={"danger"}
                                            text={"Delete"}
                                            onClick={() => onAction(template, "deleteTemplate")}
                                        />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </>
    );
};

export default PrintableTemplate;